// extracted by mini-css-extract-plugin
export default {"container":"Wp-z","brandName":"Xp-z","productName":"Yp-z","productNamePdpEnhancements":"Zp-z","breakLongProductName":"_p-z"};